import React, { Component } from "react";
import { connect } from "react-redux";
import { Route } from "react-router";
import { actions, Control, Form, track } from "react-redux-form";
import {
  Checkbox,
  Col,
  ControlLabel,
  FormControl,
  FormGroup,
  Glyphicon,
  OverlayTrigger,
  Panel,
  Row,
  Tooltip,
} from "react-bootstrap";
import { Link } from "react-router-dom";
import Truncate from "react-truncate";
import ArrowButton from "../common/button-arrow";
import classnames from "classnames";
import VoucherSelect from "./voucher-select";
import UserGroupGuard from "../common/guards/user-group";
import ConfirmPopup from "../common/confirm-popup";
import { GROUP_OWNER } from "../../data/userGroups";
import {
  setDefaultStore,
  confirmDefaultStoreChoice,
} from "../../actions/outlet";
import { Giftbox, Store as StoreLogo } from '../common/icons';

class Store extends Component {
  handleSubmit = (payLoad) => { };
  handleVoucherChange = (event) => {
    this.setState({
      voucher: event.target.value,
    });
  };
  handleRedeemChange = (model, value) => {
    this.setState({
      autoRedeem: value,
    });
    return (dispatch) => {
      dispatch(actions.change(model, value));
    };
  };

  handleSetDefault = ({ target }) => {
    if (!target.checked) return;

    const {
      dispatch,
      outlet: { id },
    } = this.props;
    dispatch(confirmDefaultStoreChoice(id));
  };

  handleConfirm = (wasConfirmed) => {
    const {
      dispatch,
      outlet: { id },
    } = this.props;

    if (wasConfirmed) {
      dispatch(setDefaultStore(id));
    } else {
      dispatch({ type: "SET_DEFAULT_STORE_CONFIRM_CANCELLED" });
    }
  };

  renderVoucherDenoms = () => {
    const voucher = this.props.vouchers.find(
      (voucher) => voucher.id == this.state.voucher
    );

    if (!voucher) return null;

    return (voucher.denominations || []).map((denom) => (
      <option key={denom.id} value={denom.id}>
        {denom.variant}
      </option>
    ));
  };

  constructor(props) {
    super(props);

    const reward = props.outlet.attributes["reward-details"] || [];

    this.state = {
      voucher: reward["voucher-type"] ? reward["voucher-type"].id : undefined,
      autoRedeem: reward["auto-redeem"],
    };
  }

  render() {
    const {
      outlet,
      registration,
      vouchers,
      features,
      isDefault,
      willBeDefault,
      settingDefaultStore,
      isConfirming,
    } = this.props;
    const reward = outlet.attributes.reward;

    const details = `/store-details/${outlet.id}`;
    const panelFooter = (
      <div className="footer-content">
        {!registration.pending && (
          <div className="details-button">
            <Link to={details}>
              {features["new_ordering"] ? (
                <ArrowButton
                  color={isDefault ? "white" : "grey"}
                  className="btn-block"
                  submit={false}
                >
                  Details
                </ArrowButton>
              ) : (
                <ArrowButton
                  color={"grey"}
                  className="btn btn-block"
                  submit={false}
                >
                  Details
                </ArrowButton>
              )}
            </Link>
          </div>
        )}
        <div className={classnames("reward-footer", { "no-reward": !reward })}>
          {reward && (
            <span>
              <Giftbox />
              Reward store
            </span>
          )}
        </div>
      </div>
    );

    if (features["new_ordering"]) {
      return (
        <Col md={4}>
          <Panel
            className={classnames("store-item", { "is-default": isDefault })}
            footer={panelFooter}
          >
            {isDefault && (
              <div className="default-store-header white">
                <StoreLogo width="40" height="40" viewBox="0 -20 256 256" />
                <span>Default Store</span>
              </div>
            )}
            <div className="store-name">
              <Truncate lines={2}>
                {outlet.attributes.name.toUpperCase()}
              </Truncate>
            </div>
            <div className="customer-number">
              {outlet.attributes["customer-number"]}
            </div>
            <div className="display-number--container">
              <span className="staff-number-title">No. staff</span>
              <span className="staff-number">
                {outlet.attributes["num-of-staff"] || 0}
              </span>
            </div>
            <Route
              path="/store-summary"
              exact
              render={() =>
                !isDefault && (
                  <UserGroupGuard type={GROUP_OWNER}>
                    <Checkbox
                      checked={isDefault || willBeDefault}
                      disabled={isDefault || settingDefaultStore}
                      onChange={this.handleSetDefault}
                      className={classnames("set-default-store", {
                        "is-default": isDefault,
                      })}
                    >
                      Make this my default store
                    </Checkbox>
                    {isConfirming && (
                      <ConfirmPopup
                        header="Change your default store"
                        onClose={this.handleConfirm}
                      >
                        <p>
                          Are you sure you want to change your default store to
                        </p>
                        <p>
                          <strong>
                            {outlet.attributes.name}{" "}
                            {outlet.attributes["customer-number"]}
                          </strong>{" "}
                          ?
                        </p>
                      </ConfirmPopup>
                    )}
                  </UserGroupGuard>
                )
              }
            />
          </Panel>
        </Col>
      );
    } else {
      return (
        <Col lg={4} className="store-item-padding">
          <Panel className="store-item" footer={panelFooter}>
            <div className="store-name">
              <div className="truncate">
                {outlet.attributes.name.toUpperCase()}
              </div>
            </div>
            <div className="customer-number">
              {outlet.attributes["customer-number"]}
            </div>
          </Panel>
        </Col>
      );
    }
  }
}

const mapStateToProps = (
  {
    viewConfig: { profile },
    stores: {
      defaultStore: { state, idToSet },
    },
    registration,
    features,
  },
  ownProps
) => {
  const defaultStoreId = profile.attributes["default-outlet-id"];
  const id = parseInt(String(ownProps.outlet.id), 10);
  const willBeDefault = Boolean(idToSet) && idToSet === id;

  return {
    registration,
    features,
    willBeDefault,
    isDefault: Boolean(defaultStoreId) && id === defaultStoreId,
    isConfirming: state === "confirming" && willBeDefault,
    settingDefaultStore: state === "pending",
  };
};
export default connect(mapStateToProps)(Store);



// WEBPACK FOOTER //
// ./src/components/store-summary/store.jsx